import React, { useEffect, useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { useGetTelephonySettingsQuery, useUpdateTranscriptionMutation } from "@/store/rest_api";
import { apiErrorMessage } from "@/util/apiError";

export default function VoicemailTranscriptionCard() {
  const { data: settings, isLoading } = useGetTelephonySettingsQuery();
  const [updateTranscription, { isLoading: isSaving }] = useUpdateTranscriptionMutation();
  const [enabled, setEnabled] = useState(false);

  async function handleToggle(next: boolean) {
    setEnabled(next);
    try {
      await updateTranscription({ enabled: next }).unwrap();
      toast.success("Setting updated");
    } catch (error: unknown) {
      setEnabled(!next);
      toast.error(apiErrorMessage(error, "Failed to update setting"));
    }
  }

  useEffect(() => {
    if (settings) {
      setEnabled(settings.transcriptionEnabled);
    }
  }, [settings]);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Voicemail transcription</CardTitle>
        <CardDescription>Read your voicemails instead of listening to them.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-row items-start justify-between rounded-lg border p-4">
          <div className="space-y-1 pr-4">
            <p className="text-base font-medium">Transcribe voicemails</p>
            <p className="text-sm text-muted-foreground">
              Voicemails left on your call flows are written out, and the text is included in the notification you
              receive. Transcription is charged at{" "}
              <span className="font-medium tabular-nums">${settings?.transcriptionRate ?? 0}</span> per transcribed
              minute. With this off, no voicemail is transcribed and nothing is charged.
            </p>
          </div>
          <Switch checked={enabled} disabled={isLoading || isSaving} onCheckedChange={handleToggle} />
        </div>
      </CardContent>
    </Card>
  );
}
